import { AuthenticationDataProvider } from "./authentication/AuthenticationContext";
import { CredentialDefinitionsDataProvider } from "./credentialDefinitions/CredentialDefinitionsContext";
import { CredentialsDataProvider } from "./credentials/CredentialsContext";
import { LanguageDataProvider } from "./language/LanguageContext";
import { ProofsDataProvider } from "./proofs/ProofsContext";
import { SchemasDataProvider } from "./schemas/SchemasContext";
import { CategoriesDataProvider } from "./categories/CategoriesContext";
import { UsersDataProvider } from "./users/UsersContext";
import { InvitationsDataProvider } from "./invitations/InvitationsContext";
import { RequestsDataProvider } from "./requests/RequestsContext";
import { StepsDataProvider } from "./steps/StepsContext";
import { IconsDataProvider } from "./icons/IconsContext";
import { PresentationsDataProvider } from "./presentation/PresentationsContext";
import { ProfilesDataProvider } from "./usersProfile/ProfilesContext";

// This is setup so we do not have to do this at the index.tsx. If you add a provider, please do the same at the
// __testUtils__ folder
export const GlobalContextProvider = ({ children }: any) => {
  return (
    <LanguageDataProvider>
      <AuthenticationDataProvider>
        <SchemasDataProvider>
          <CategoriesDataProvider>
            <IconsDataProvider>
              <CredentialDefinitionsDataProvider>
                <CredentialsDataProvider>
                  <ProofsDataProvider>
                    <PresentationsDataProvider>
                      <RequestsDataProvider>
                        <InvitationsDataProvider>
                          <StepsDataProvider>
                            <ProfilesDataProvider>
                              <UsersDataProvider>{children}</UsersDataProvider>
                            </ProfilesDataProvider>
                          </StepsDataProvider>
                        </InvitationsDataProvider>
                      </RequestsDataProvider>
                    </PresentationsDataProvider>
                  </ProofsDataProvider>
                </CredentialsDataProvider>
              </CredentialDefinitionsDataProvider>
            </IconsDataProvider>
          </CategoriesDataProvider>
        </SchemasDataProvider>
      </AuthenticationDataProvider>
    </LanguageDataProvider>
  );
};
